import React from 'react'
import Slider from 'react-slick'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import {
  fetchEventsIfNeeded,
  invalidateEvents
} from '~/events/actions'
import {
  fetchNodeIfNeeded,
} from '~/nodes/actions'
import { DateTime } from 'luxon'

class Events extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventItem: null,
      visible: false
    }
    this.clicked = this.clicked.bind(this)
  }

  componentDidMount(){
    const {dispatch} = this.props
    dispatch(fetchEventsIfNeeded())
  }
  componentWillReceiveProps(props) {
    const { match, dispatch, nodes } = props
    if (match && match.params && match.params.id)
    {
      let id = match.params.id
      if(id) {
        dispatch(fetchNodeIfNeeded(id))
        if(nodes[id] && nodes[id].body) {
          this.setState( {eventItem: nodes[id]} )
        }
      }
    }
  }

  clicked(item){
    console.log(item)
    this.setState( {eventItem: item} )
  }

  render() {
    const { events } = this.props
    const { eventItem } = this.state

    let eventBox = null

    if (eventItem) {
      eventBox =
      <div className="event-item">
        <div className="poster">
          <img src={eventItem.field_event_image[0].url} />
        </div>
        <div className="info">
          <h3>{eventItem.title[0].value}</h3>
          <p>{ DateTime.fromISO(eventItem.field_event_date[0].value).toLocaleString(DateTime.DATE_SHORT) }</p>
          <div dangerouslySetInnerHTML={{ __html: eventItem.body[0].value }}></div>
        </div>
          {/*<div>{item.field_event_teaser[0].value}</div>*/}
      </div>
    }

    const eventBoxes = events.items.map( ( item, index) =>
      <div onClick={(e) => this.clicked(item, e)} className={item.zed_event.length === 0 || item.zed_event[0].value === false ? "event-box zed-presents" : "event-box zed-event" } key={index}>
        <div className="header"> </div>
        <img src={item.field_event_image[0].url} />
        <h3>{item.title[0].value}</h3>
        <p>{ DateTime.fromISO(item.field_event_date[0].value).toLocaleString(DateTime.DATE_SHORT) }</p>
        <div className="footer"></div>
        {/*<div>{item.field_event_teaser[0].value}</div>*/}
      </div>
    )

    if (events.items.length >= 1) {
			 return (
	      <div className="events margin">
	        <h2>Upcoming</h2>
	        {eventBox}
	        <div className="event-box-wrapper">
	          {eventBoxes}
	        </div>
	      </div>
	    )
		} else {
			return null;
		}
  }
}

export default connect(state => ({events: state.events, nodes: state.nodes})) (Events)
